export default __webpack_public_path__ + "static/media/team109.e7ac6186.JPG";